module.exports = __webpack_public_path__ + "static/media/ntu.64095e7b.png";